<script>
import { VAutocomplete } from 'vuetify/lib'
import inputMixin from '@/vuetify-mixins/input-mixin'
export default {
	extends: VAutocomplete,
	mixins: [inputMixin],
}
</script>
